export default "__VITE_ASSET__DZOzXLGR__"